import { BaseEdge, EdgeLabelRenderer, getBezierPath, type Edge, type EdgeProps } from '@xyflow/react';
import type { ProcessExecuteIntervalType, ProcessIntervalAnchor } from '@econtractor/types';
import ProcessIntervalLabel from './ProcessIntervalLabel';

export type ProcessDiagramEdgeData = {
    label: string;
    inactive?: boolean;
    interval: ProcessExecuteIntervalType | null;
    intervalAnchor?: ProcessIntervalAnchor | null;
};

export type ProcessDiagramEdgeType = Edge<ProcessDiagramEdgeData>;

export const ProcessDiagramEdge = ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style,
    data,
    markerEnd,
}: EdgeProps<ProcessDiagramEdgeType>) => {
    const [path, labelX, labelY] = getBezierPath({ sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition });
    return (
        <>
            <BaseEdge id={id} path={path} markerEnd={markerEnd} style={style} />
            {data?.label ? (
                <EdgeLabelRenderer>
                    <span
                        className={`process-diagram-edge-label badge text-bg-light ${data.inactive ? 'opacity-50' : ''}`}
                        style={{ transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)` }}
                    >
                        <ProcessIntervalLabel interval={data.interval} anchor={data.intervalAnchor} />
                    </span>
                </EdgeLabelRenderer>
            ) : null}
        </>
    );
};
